// src/components/inspector/InspectorLayout.jsx
import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useInspectorAuth } from '../../context/InspectorAuthContext';
import styles from './InspectorLayout.module.css';

const NAV = [
  { to: '/inspector/dashboard', icon: '⊞', label: 'Dashboard' },
  { to: '/inspector/inspections', icon: '🔍', label: 'My Inspections' },
  { to: '/inspector/schedule', icon: '📅', label: 'Schedule' },
];

export default function InspectorLayout({ children }) {
  const { inspector, logout } = useInspectorAuth();
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/inspector/login');
  };

  return (
    <div className={styles.root}>
      {/* Sidebar */}
      <aside className={`${styles.sidebar} ${collapsed ? styles.collapsed : ''}`}>
        <div className={styles.brand}>
          <span className={styles.brandIcon}>🔧</span>
          {!collapsed && (
            <div>
              <div className={styles.brandName}>AucwiniCars</div>
              <div className={styles.brandRole}>INSPECTOR PORTAL</div>
            </div>
          )}
          <button
            className={styles.collapseBtn}
            onClick={() => setCollapsed(!collapsed)}
            title={collapsed ? 'Expand' : 'Collapse'}
          >
            {collapsed ? '›' : '‹'}
          </button>
        </div>

        <nav className={styles.nav}>
          {NAV.map(({ to, icon, label }) => (
            <NavLink
              key={to}
              to={to}
              className={({ isActive }) =>
                `${styles.navItem} ${isActive ? styles.active : ''}`
              }
            >
              <span className={styles.navIcon}>{icon}</span>
              {!collapsed && <span className={styles.navLabel}>{label}</span>}
            </NavLink>
          ))}
        </nav>

        <div className={styles.userSection}>
          <div className={styles.avatar}>
            {inspector?.name?.[0]?.toUpperCase() || inspector?.email?.[0]?.toUpperCase() || 'I'}
          </div>
          {!collapsed && (
            <div className={styles.userInfo}>
              <div className={styles.userName}>{inspector?.name || 'Inspector'}</div>
              <div className={styles.userEmail}>{inspector?.email}</div>
            </div>
          )}
          <button
            className={styles.logoutBtn}
            onClick={handleLogout}
            title="Logout"
          >
            ⏻ {!collapsed && <span style={{ marginLeft: '6px' }}>Logout</span>}
          </button>
        </div>
      </aside>

      {/* Main content */}
      <main className={styles.main}>
        {children}
      </main>
    </div>
  );
}